module.exports = lib_eui;